<template>
  
  <v-layout class="rounded rounded-md" style="height:100%;">

        <NavigationView ref="nav" @setDrawer="setDrawer" @setDrawerState="setDrawerState" />      

        <HeaderView ref="header" @setDrawer=setDrawer></HeaderView>

        <v-main class="d-flex justify-center" style="min-height: 300px; height:100%">
          <router-view @load="setLoad()" />                  
        </v-main>   
        
    </v-layout>

    <div class="v-overlay-container" v-if="proxy.$store.state.commStore.serverCallCount">
      <div class="v-overlay v-overlay--active v-theme--light v-locale--is-ltr v-dialog v-overlay--scroll-blocked" aria-modal="true" role="dialog" style="z-index: 2400;">
        <div class="v-overlay__scrim"></div>
      </div>
    </div>
  
</template>

<script setup>

  import { ref, getCurrentInstance } from "vue";
  import HeaderView from './HeaderView.vue';
  import NavigationView from './NavigationView.vue';        

  const { proxy } = getCurrentInstance();

  const nav = ref(null);

  const header = ref(null);

  const setDrawer = () => {
    nav.value.drawerUpdate();
    header.value.drawerUpdate();
  }

  const setLoad = () => {    
    nav.value.load();
  }

  const setDrawerState = (val) => {
    if (header.value) {
        header.value.setDrawerState(val);
    }
  }
  
</script>